import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'app-sample-input',
    templateUrl: './sample-input.component.html',
})
export class SampleInputComponent implements OnInit{

    @Input('title') title: any;
    @Input('value') value: any;
    @Input('copy') copy?: boolean;

    constructor(){
        this.copy = false
    }

    ngOnInit(){
    }

    touchInput(event){
        console.log(event);
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/forms/sample-input/sample-input.component.ts